import { render } from "./LoginRegister3.vue?vue&type=template&id=b4f5be48&scoped=true"
import script from "./LoginRegister3.vue?vue&type=script&lang=js"
export * from "./LoginRegister3.vue?vue&type=script&lang=js"

import "./LoginRegister3.vue?vue&type=style&index=0&id=b4f5be48&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4f5be48"]])

export default __exports__